import {React, useState, useEffect, useRef} from "react";
import TeamModal from "../TeamForm/TeamForm"; 

const JointeamSection = () => {
  
  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef(null);
    
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") setOpenModal(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [ openModal]);

  return (
    
    <>
    <div className="Join-Section">
      <div className="container tw-px-4">
        <div
          className=" row tw-bg-[#157438] tw-text-white tw-p-[30px] md:tw-p-[40px] tw-my-[50px] tw-mx-auto tw-rounded-[30px] tw-flex tw-flex-wrap"
        >
          {/* Left Content */}
          <div className="col-sm-9 col-12"> 
            <h5 className="tw-mb-2">Join the team</h5>

            <h2 className="tw-text-[32px] tw-font-semibold tw-leading-tight tw-mb-4 max-md:tw-text-[24px]">
              Become part of a team that is redefining how the
              <br />
              AEC industry builds and collaborates.
            </h2>

            <p className="tw-p-0 tw-m-0 tw-font-extralight tw-leading-relaxed">
              At Fractile, you'll work on impactful projects, learn from seasoned
              leaders, and grow your technical craft. If you're committed to
              excellence, we're committed to you.
            </p>
          </div>

          {/* Right Button */}
          <div className="col-sm-3 col-12 tw-flex tw-items-end max-sm:tw-mt-6 md:tw-pt-0 tw-pt-5">
            <button className="btn-2-white  tw-w-[80%] md-tw-w-[350px]" onClick={() => setOpenModal(true)}>
              Explore Opportunity
            </button>
          </div>
        </div>
      </div>
    </div>
          
      <TeamModal isOpen={openModal} onClose={() => setOpenModal(false)}/>    
    </>
  );
};

export default JointeamSection;
